// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__nb5sJ","ldsRoller":"loading_ldsRoller__eY21j","lds-roller":"loading_lds-roller__It8-c"};